import { compact as lo_compact } from 'es-toolkit';

// TODO: Migrate UserAvatar 'initials' logic here
// export function fullNameToInitials(
//     fullName: string | string[],
//     fallback: Nilish<string>
// ): string {
//     let arr = !Array.isArray(fullName) ? fullName.split(' ') : fullName;
//     let str = fallback ?? '';

//     if (arr.length) {
//         if (arr.length > 2) {
//             arr.splice(1, arr.length - 2);
//         }

//         str = arr.map((n) => n.charAt(0))
//             .join('')
//             .toUpperCase();
//     }

//     return str;
// }

export function nameToFirstLastInitials(
    name: string | string[],
    fallback: Nilish<string> = ''
): string {
    if (!name.length) {
        return fallback || '';
    }

    let str = '';
    let arr = lo_compact(!Array.isArray(name) ? name.split(' ') : name);

    if (arr.length) {
        if (arr.length > 2) {
            arr.splice(1, arr.length - 2);
        }

        str = arr.map((n, idx) => idx === 0 ? n : `${n.charAt(0)}.`)
            .join(' ');
    }

    return str;
}
